/* GROUP */
export const GET_LESSON = "GET_LESSON"
export const GET_LESSON_SUCCESS = "GET_LESSON_SUCCESS"
export const GET_LESSON_CLEAN = "GET_LESSON_CLEAN"
export const GET_LESSON_ERROR = "GET_LESSON_ERROR"
